import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
function BaoDocumentViewModel(tabPage) {
    var self = this;
    self.TabPage = tabPage;
    self.DocumentFound = ko.observable(false);
}
BaoDocumentViewModel.prototype.Download = function () {
    var self = this;
    if (self.DocumentFound(true)) {
        window.open(window.absolutePath + "BaoDocument/Download/" + self.getFileId(), "_blank");
    }
};
BaoDocumentViewModel.prototype.loaded = function () {
    var self = this;
    if (self.DocumentFound()) {
        self.Download();
    }
};
BaoDocumentViewModel.prototype.getFileId = function () {
    var self = this;
    var id = self.TabPage.ObjectId();
    var docid = baoRouter.getRouteValue("docid", self.TabPage);
    if (docid != null && docid != "") {
        id = docid;
    }
    return id;
};
BaoDocumentViewModel.prototype.init = function () {
    var self = this;
    self.TabPage.Title("Download");
    return Bao.post("BaoDocument/Get", JSON.stringify({
        id: self.getFileId()
    }), function (result) {
        if (result == true) {
            self.DocumentFound(true);
        }
    });
};
export default BaoDocumentViewModel;